// Confirmation uses the platform <dialog>: focus trap, Escape to cancel and the backdrop come free.

import { html } from './html.ts';
import { t } from './i18n.ts';

export function confirmDialog(o: { title: string; body: string; yes: string }): Promise<boolean> {
  const d = document.getElementById('confirm') as HTMLDialogElement;
  d.innerHTML = html`<form method="dialog" class="sheet">
    <h2 id="confirm-title">${o.title}</h2>
    <p>${o.body}</p>
    <button class="btn" value="yes" autofocus>${o.yes}</button>
    <button class="quiet" value="no">${t('common.notNow')}</button>
  </form>`.value;
  d.setAttribute('aria-labelledby', 'confirm-title');
  d.returnValue = '';
  d.showModal();
  return new Promise((resolve) => d.addEventListener('close', () => resolve(d.returnValue === 'yes'), { once: true }));
}
